import React from 'react';
import { compose, withState, withHandlers } from 'recompose';
import styled from '@emotion/styled';
import cn from 'classnames';

import Popover from '../popover';
import { qaSel } from '../../common/utils';
import { Icon } from 'infl-icons';
import { Link } from './style.js';
import styles from './style.css';
import { trackClick } from '../../common/tracking-utils';
import { isCurrPageWithOverrides } from '../../common/discourse-utils';

const ContentSectionLink = styled('li')`
  display: inline-block;
  cursor: pointer;
  margin: 0 ${props => props.theme.spacing[4]}px 0 0;
  font-weight: 300;
  -webkit-font-smoothing: antialiased;
  &:first-child {
    margin-left: 0;
  }
  font-size: ${props => props.theme.fonts.size[3]}px;
  font-weight: ${props => props.selected ? props.theme.fonts.weight[3] : props.theme.fonts.weight[1]} !important;
  color: ${props => props.selected ? props.theme.colors.primary[0] : props.theme.colors.neutral[1]} !important;
  &:focus, &:active, &:hover {
    text-decoration: none;
    color: ${props => props.theme.colors.primary[0]} !important;
  }
`;

let popOverRef = null;

const ContentSectionsDropDown = compose(
  withState('dropDownIsOpen', 'setDropDownIsOpen', false),
  withHandlers({
    onContentDropdownClick: ({ dropDownIsOpen, setDropDownIsOpen }) => () => {
      setDropDownIsOpen(!dropDownIsOpen);
    }
  })
)(({ sectionsForDrownDown, currentPageOverride, onContentDropdownClick,  dropDownIsOpen }) => (
  <ContentSectionLink selected={Object.keys(currentPageOverride).length !== 0}
    ref={node => popOverRef = node} onClick={onContentDropdownClick}>
    More <span className={cn(styles.contentSectionCaret, 'c-content-section-caret')}>
      <Icon icon="chevron-down" title="Chevron down" />
    </span>
    <Popover
      target={popOverRef}
      show={dropDownIsOpen}
      minWidth="initial">
      <ul className={cn(styles.navList, 'c-nav-list')}>
        {sectionsForDrownDown.map(section =>
          <Link
            key={section.path}
            type={section.type}
            data-qa={qaSel(`top-nav-link-${section.type}`)}
            href={section.path}
            onClick={trackClick(section.type)}
            selected={isCurrPageWithOverrides(
              currentPageOverride[section.path],
              Object.keys(currentPageOverride).length !== 0,
              section.type
            )}>
            <li className={cn(styles.contentSectionItem, 'c-content-section-item')}>
              {section.label}
            </li>
          </Link>
        )}
      </ul>
    </Popover>
  </ContentSectionLink>
));

export default ContentSectionsDropDown;
